import React, { useState } from 'react';
import NavBar from './NavBar';
import Calculator from './Calculator';
import MainBlockBotBtns from './MainBlockBotBtns';
import '../../css/style.css'


const MainBlock = (props) => {

    return (
<section className="mainBlock w-[98%] mx-auto h-full mt-[70px] bg-cover rounded-3xl bg-50% sm:mt-6" style={{ backgroundImage: `url(${props.data.background[0].bg})` }}>
    <div className={`mainBlock__container w-full h-full bg-[#000] bg-opacity-35 rounded-3xl flex flex-col justify-between`}>
        <div className='hidden sm:block'>
            <NavBar 
            data={props.data}
            logo={props.data.logo[0]}
            color={props.data.colors[0].colorWhite}
            burger={props.data.burgerDesc[0]}
            authorized={props.authorized}
            setAuthorized={props.setAuthorized}
            isOpen={props.isOpen}
            toggleMenu={props.toggleMenu}
        />
        </div>
        
        <div className='flex lg:flex-nowrap flex-wrap h-full w-full'>
            <div className="flex  flex-col gap-[42px] p-[20px] md:justify-between flex-grow sm:py-0">
                <div className=' flex flex-col gap-[12px] md:gap-[24px] lg:gap-[32px] mt-[10px]'>
                    <h1 className={` text-[32px] font-[500] max-w-[672px] leading-[1.2] lg:text-[52px] md:text-[48px] sm:text-[32px]`}
                    style={{
                        color: props.data.colors[0].colorWhite
                    }}>
                        {props.data.text[0].textTitle}
                    </h1>
                    <p className={` text-[14px] font-[400] max-w-[531px] leading-[1.2] md:text-[20px] sm:text-[16px] `}
                    style={{
                        color: props.data.colors[0].colorWhite
                    }}>
                        {window.innerWidth <= 640
                                ? (props.data.text[0].textDescMob)
                                : 
                                (props.data.text[0].textDesc)}
                    </p>
                </div>
                <div className="pb-[20px]">
                    <MainBlockBotBtns data={props.data}/>
                </div>
            </div>
            <div className='lg:w-auto w-full mt-2 p-[5px] sm:p-[20px]'>
                <Calculator />
            </div>
        </div>
    </div>
</section>


    );
};

export default MainBlock;